import { ref as e } from "vue";
class a {
  isLoading;
  shimmerSize;
  /**
   * Loading state manager constructor.
   *
   * @param shimmerSize Shimer size argument for constructor.
   */
  constructor(i) {
    this.isLoading = e(!1), this.shimmerSize = e(i);
  }
  /**
   * Get loading state reference.
   *
   * @returns Ref<boolean> Return loading state reference.
   */
  getLoadingState() {
    return this.isLoading;
  }
  /**
   * Set value from the property.
   *
   * @param value Loading property value.
   */
  setLoadingState(i) {
    this.isLoading.value = i;
  }
  /**
   * Get shimmer size.
   *
   * @returns Ref<ShimmerSize> Return the shimmer size reference object.
   */
  getShimmerSize() {
    return this.shimmerSize;
  }
  /**
   * Calculates the shimmer size using container reference.
   *
   * @param container Container reference.
   */
  calculateShimmerSize(i) {
    this.shimmerSize.value = {
      width: i.clientWidth,
      height: i.clientHeight
    };
  }
}
export {
  a as LoadingStateManager
};
//# sourceMappingURL=loading-state-manager.js.map
